import React from 'react';
import { Box, Typography } from '@mui/material';
import Messaging from './messaging';

/**
 * Messaging Page - Standalone route for messaging/notifications management
 * Previously a tab in the Admin component
 */
export default function MessagingPage() {
  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        Messaging & Notifications
      </Typography>
      <Messaging />
    </Box>
  );
}
